import clsx from 'clsx'
import { FC, useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import { toAbsoluteUrl } from '../../../helpers'
import { apiGetCustomer } from '../../../../app/redux/api'
import * as devices from '../../../../app/redux/DevicesRedux'

const Toolbar2: FC = () => {
  const dispatch = useDispatch()

  const customer: any = useSelector<RootState>(
    ({ device }) => device.customer,
    shallowEqual
  )

  const accessToken: any = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual)

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (accessToken) {
      getCustomer(accessToken)
    }
  }, [accessToken])

  const getCustomer = (accessToken: any) => {
    setLoading(true)

    const query: any = {
      'access-token': accessToken
    }

    apiGetCustomer(query)
      .then(({ data }) => {
        if (data && data.response) {
          dispatch(devices.actions.setCustomer(data.response));
          setLoading(false)
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  return (
    <>
      <div className={clsx('cursor-pointer d-flex align-items-center')}>
        {customer &&  customer.CompanyLogo ? (
          <img className="company-logo object-fit-contain" src={customer.CompanyLogo} alt='customer' />
        ) : (
          <img className="company-logo object-fit-contain" src={toAbsoluteUrl('/media/logos/iFleetcam_logo.png')} alt='customer' />
        )}
      </div>
    </>
  )
}

export { Toolbar2 }
